import { useTranslation } from "react-i18next";
import { ReactComponent as File } from "assets/icons/file.svg";
import { ReactComponent as ArrowLeft } from "assets/icons/arrow-left-primary.svg";
import ContractLoading from "containers/pmaOnboarding/components/loading/contractLoading";

import ContractButton from "./buttons";

const ContractList = ({ loading, data, onShowContract, onShowUserInfo }) => {
  const { t } = useTranslation();
  const isSigned = (status) => status === "SIGNED";
  return loading ? (
    <ContractLoading />
  ) : (
    <>
      <div className="p-5">
        <div className="flex flex-col gap-4">
          {data.map((el) => (
            <div
              className="flex justify-between gap-4 items-center bg-white rounded-lg shadow-lg p-4 cursor-pointer"
              key={el.id}
              onClick={() => onShowContract(el)}
            >
              <div>
                <div className="flex gap-2 mb-2">
                  <File width={20} height={20} />
                  <span className="body-14px-medium text-gray-4">
                    {el.name}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span
                    className={`caption-10px-demibold ${
                      isSigned(el.status)
                        ? "text-success-0 bg-success--8"
                        : "text-warning-0 bg-warning--7"
                    }  px-2 py-0.5 rounded`}
                  >
                    {isSigned(el.status)
                      ? t("pma-onboarding.signed")
                      : t("pma-onboarding.unsigned")}
                  </span>
                </div>
              </div>
              <ArrowLeft className="w-4 h-4 [&>path]:fill-gray-0 cursor-pointer" />
            </div>
          ))}
        </div>
      </div>
      {data?.every((el) => el.status === "NOT_SIGNED") && (
        <ContractButton onClick={onShowUserInfo} />
      )}
    </>
  );
};

export default ContractList;
